import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AppCasinoState, CasinoGameModelExt, GameWrapperType } from 'src/domains/casino/state/AppCasino.state';
import { GameImgWrapperLazy, GameWrapper } from './SingleGameExt.style';
import { JackpotBar } from './jackpot-bar/JackpotBar';
import { RealTimeLobby } from './real-time-lobby/RealTimeLobby';
import { ThumbnailOverlay } from './thumbnail-overlay/ThumbnailOverlay';
import { useCommon } from 'src/domains/common/Common';
import { JackpotsSocket } from 'src/domains/casino/state/AppCasino/casino-sockets/jackpot-socket/JackpotsSocket';
import { JACKPOT_GAMES_NAME } from 'src/domains/casino/state/AppCasino/HomeCollections.state';

const getImageForWrapper = (
    gameModel: CasinoGameModelExt,
    wrapperType: GameWrapperType,
    isFirstTile: boolean | undefined
): string => {
    if (wrapperType === 'slider-grid' && isFirstTile === true) {
        return gameModel.imageSquare;
    }

    if (wrapperType === 'numeric-trending') {
        return gameModel.imageVertical;
    }

    return gameModel.imageHorizontal;
};
interface PropsType {
    appCasinoState: AppCasinoState;
    gameModel: CasinoGameModelExt;
    wrapperType?: GameWrapperType;
    showModalOnMobile?: boolean;
    showLikeAndInfo?: boolean;
    showRealTimeLobby?: boolean;
    isFirstTile?: boolean;
}

export const SingleGameExt = observer('SingleGameExt', (props: PropsType) => {
    const { appCasinoState, gameModel, isFirstTile } = props;
    const common = useCommon();

    const jackpotEnabled = common.features.casinoJackPot;

    const thumbnailConfigSettings = common.features.gameThumbnailSettings[gameModel.collection];
    const wrapperType = props.wrapperType ?? thumbnailConfigSettings.wrapperType;
    const showModalOnMobile = props.showModalOnMobile ?? thumbnailConfigSettings.showModalOnMobile;
    const showLikeAndInfo = props.showLikeAndInfo ?? thumbnailConfigSettings.showLikeAndInfo;
    const showRealTimeLobby = props.showRealTimeLobby ?? thumbnailConfigSettings.showRealTimeLobby;

    const imageToDisplay = getImageForWrapper(gameModel, wrapperType, isFirstTile);

    const showModal = (): void => {
        appCasinoState.casinoSidebarGameInfoState.showSidebar(gameModel.id);
        appCasinoState.redirectState.resetRealityCheckTime();
    };

    const handleOnMobileClick = (): void => {
        if (showModalOnMobile) {
            showModal();
        } else {
            gameModel.startGame();
        }
    };

    const isJackpotGame =
        appCasinoState.gameStoreExt
            .getCollection('casino')
            .getCategoryByName(JACKPOT_GAMES_NAME)
            ?.game_ids.includes(gameModel.id) ?? false;
    const jackpotModel =
        isJackpotGame && jackpotEnabled ? JackpotsSocket.get(common).getModel(props.gameModel.id) : null;

    const imgThumbnailSize = isFirstTile === true ? 552 : 360;

    return (
        <GameWrapper
            wrapperType={wrapperType}
            borderRadius={jackpotEnabled && jackpotModel !== null}
            title={gameModel.name}
            data-test-game-id={gameModel.id}
        >
            <GameImgWrapperLazy
                alt={gameModel.name}
                imgFit='fill'
                imgBase={{
                    src: imageToDisplay,
                    optimizeOptions: {
                        width: imgThumbnailSize,
                        quality: 85,
                    },
                }}
                onClick={handleOnMobileClick}
                placeholder={true}
            />
            {jackpotEnabled && jackpotModel !== null ? (
                <JackpotBar
                    jackpotModel={jackpotModel}
                    isBigTile={isFirstTile ?? false}
                />
            ) : null}

            <RealTimeLobby
                appCasinoState={appCasinoState}
                gameModel={gameModel}
                showRealTimeLobby={showRealTimeLobby}
            />
            <ThumbnailOverlay
                appCasinoState={appCasinoState}
                gameModel={gameModel}
                showLikeAndInfo={showLikeAndInfo}
                handleOnMobileClick={handleOnMobileClick}
                handleInfoClick={showModal}
            />
        </GameWrapper>
    );
});
